<template>
    <div v-if="!loading" id="payment">
        <div class="payment-texts header" v-if="interval === null">
            <h3>See how your dimensional <span class="nowrap">HOO-R-U Score</span> compares to that of your peers.</h3>
            <p>You can use your results to monitor your social media image and even improve upon it—if you so desire. You may even want to share your profile with some of your friends and online contacts to spark an interesting conversation.</p>
        </div>
        <div v-if="interval === null" id="payment-container-wrapper">
            <h3>Get your <span class="nowrap">HOO-R-U</span> Dimensional Profile for just ${{ Math.floor(price / 100) }}.{{ Math.floor(price / 10) % 10 }}{{ price % 10 }}</h3>
            <div id="payment-container">
                <ul class="radio-container">
                    <li :class="{'selected': payment_method === 'cc'}">
                        <label><input type="radio" name="payment_method" v-model="payment_method" value="cc"><span>Credit card</span></label>
                        <div class="payment-method-container" v-if="payment_method === 'cc'">
                            <div id="card-element-wrapper">
                                <form id="stripe-payment-form">
                                    <div style="display: flex">
                                        <div id="card-element"></div>
                                        <button :disabled="stripe_loading">Submit</button>
                                    </div>
                                    <div id="stripe-form-details">
                                        <div id="card-errors" role="alert"></div>
                                        <div class="powered-by-stripe"><img src="./../assets/img/powered_by_stripe.png" alt="" /></div>
                                    </div>
                                </form>
                            </div>
                            <div class="hr" v-if="payment_btn_available"></div>
                            <div id="payment-request-button-wrapper" v-if="payment_btn_available"><div id="payment-request-button"></div></div>
                        </div>
                    </li>
                    <li :class="{'selected': payment_method === 'paypal'}">
                        <label><input type="radio" name="payment_method" v-model="payment_method" value="paypal"><span>PayPal</span></label>
                        <div class="payment-method-container" v-if="payment_method === 'paypal'">
                            <div id="paypal-button-container"></div>
                        </div>
                    </li>
                </ul>
                <p v-if="!show_coupon_code" id="coupon-link"><span class="a" @click="toggle_coupon_form">Have a coupon?</span></p>
                <form v-else @submit="apply_coupon" id="coupon-form">
                    <input type="text" v-model="coupon" required="required" placeholder="Coupon code" /><button>Apply coupon</button>
                </form>
            </div>
        </div>
        <Loader v-else text="Waiting for payment being processed"></Loader>
        <div class="payment-texts" v-if="interval === null">
            <p><strong>The HOO-R-U Score</strong> is an extension of Charles Horton Cooley’s groundbreaking work that culminated in his book <em>“Human Nature and the Social Order”</em> that was published in 1902. Cooley’s Looking Glass Self Concept is particularly applicable to social media members whose self-image is necessarily a reflection of people, businesses, organizations, etc., with whom members interact anonymously online.</p>
            <p>The looking-glass self is based on self reflection and develops in stages: (1) We imagine how we appear to others; (2) We imagine the judgments they make about us; and (3) We develop our own self-identity through the judgments of others.</p>
        </div>
    </div>
    <Loader v-else></Loader>
</template>

<script>
  import Ajax from './../utils/Ajax'
  import Loader from './../components/Loader'

  export default {
    name: 'Payment',
    props: ['callback', 'access_token', 'price_prop'],
    data: function() {
      return {
        'loading': true,
        'stripe_loading': false,
        'interval': null,
        'show_coupon_code': false,
        'coupon': '',
        'price': this.$props.price_prop,
        'payment_btn_available': true,
        'payment_method': 'cc',
        'real_payment_method': null,
      }
    },
    components: {
      Loader
    },
    created: function(){
      window.gtag && window.gtag('event', 'questionnaire-action', {
        'event_category': 'payment-page-status',
        'event_label': 'loading'
      });
      setTimeout(() => {this.$children[0].set_loader_text('Analyzing Profile Dimensions ... <strong class="hidden">COMPLETE</strong>')}, 100);
      setTimeout(() => {this.$children[0].set_loader_text('Analyzing Profile Dimensions ... <strong class="green">COMPLETE</strong>')}, 1100);
      setTimeout(() => {this.$children[0].set_loader_text('Comparing Profile Dimensions to Your Peers ... <strong class="hidden">COMPLETE</strong>')}, 2100);
      setTimeout(() => {this.$children[0].set_loader_text('Comparing Profile Dimensions to Your Peers ... <strong class="green">COMPLETE</strong>')}, 3100);
      setTimeout(() => {this.$children[0].set_loader_text('HOO-R-U Scored Dimensional Profile ... <strong class="hidden">COMPLETE</strong>')}, 4100);
      setTimeout(() => {this.$children[0].set_loader_text('HOO-R-U Scored Dimensional Profile ... <strong class="green">COMPLETE</strong>')}, 5100);
      setTimeout(this.render_screen.bind(this), 6100);
    },
    watch: {
      'payment_method': function () {
        this.render_payment_method();
      }
    },
    methods: {
      'create_order': function(data, actions) {
        return actions.order.create({
          purchase_units: [{
            amount: {
              value: this.$data.price / 100
            }
          }]
        });
      },
      'render_screen': function () {
        window.gtag && window.gtag('event', 'questionnaire-action', {
          'event_category': 'payment-page-status',
          'event_label': 'rendering'
        });
        this.$data.loading = false;
        this.$data.show_coupon_code = false;
        this.$data.coupon = '';
        this.render_payment_method();
      },
      'render_payment_method': function () {
        if (this.$data.payment_method === 'cc') {
          this.render_cc();
        } else if (this.$data.payment_method === 'paypal') {
          this.render_paypal();
        }
      },
      'render_cc': function () {
        setTimeout(() => {
          const stripe = Stripe(this.STRIPE_PUBLIC_KEY);
          const elements = stripe.elements();
          const style = {
            base: {
              color: '#000000',
              fontFamily: '"Roboto Condensed", sans-serif',
              fontSmoothing: 'antialiased',
              fontSize: '1rem',
              '::placeholder': {
                color: '#dddddd'
              }
            },
            invalid: {
              color: '#e37d4e',
              iconColor: '#e37d4e'
            }
          };
          const card = elements.create('card', {style});
          card.mount('#card-element');
          card.addEventListener('change', ({error}) => document.getElementById('card-errors').textContent = error ? error.message : '');
          const form = document.getElementById('stripe-payment-form');
          form.addEventListener('submit', async (e) => {
            e.preventDefault();
            this.$data.stripe_loading = true;
            const {token, error} = await stripe.createToken(card);
            if (error) {
              document.getElementById('card-errors').textContent = error.message;
              this.$data.stripe_loading = false;
            } else {
              //this.$data.loading = true;
              const url = `${this.API_BASE}/payment/${this.$props.access_token}/stripe`;
              this.$data.real_payment_method = 'stripe-form';
              Ajax.ajax('POST', url, token).then(this.payment_saved.bind(this));
            }
          });

          const paymentRequest = stripe.paymentRequest({
            country: 'US',
            currency: 'usd',
            total: {
              label: 'HOO-R-U',
              amount: this.$data.price,
            },
            requestPayerName: false,
            requestPayerEmail: false,
          });

          const prButton = elements.create('paymentRequestButton', { paymentRequest });

          paymentRequest.canMakePayment().then(res => {
            if (res) {
              prButton.mount('#payment-request-button');
            } else {
              this.$data.payment_btn_available = false;
            }
          });

          paymentRequest.on('token', async (ev) => {
            // Send the token to your server to charge it!
            const url = `${this.API_BASE}/payment/${this.$props.access_token}/stripe`;
            Ajax.ajax('POST', url, ev.token).then((r) => {
              if (r.response.success){
                ev.complete('success');
              } else {
                ev.complete('fail');
              }
              this.$data.real_payment_method = 'stripe-button';
              this.payment_saved(r);
            }).catch(() => {
              ev.complete('fail');
            });
          });
        }, 1);
      },
      'render_paypal': function () {
        setTimeout(() => {
          paypal.Buttons({
            style: {
              layout: 'horizontal'
            },
            createOrder: this.create_order.bind(this),
            onApprove: this.submit_payment.bind(this)
          }).render('#paypal-button-container');
        }, 1);
      },
      'submit_payment': function(data, actions) {
        return actions.order.capture().then((details) => {
          this.$data.loading = true;
          const url = `${this.API_BASE}/payment/${this.$props.access_token}/paypal`;
          this.$data.real_payment_method = 'paypal';
          Ajax.ajax('POST', url, data).then(this.payment_saved.bind(this));
        });
      },
      'payment_saved': function (r) {
        if (r.response.success){
          window.gtag && window.gtag('event', 'questionnaire-action', {
            'event_category': 'payment-saved',
            'event_label': this.$data.real_payment_method,
            'value': this.$data.price
          });
          this.$props.callback();
        } else {
          alert('Error');
        }
        this.$data.loading = false;
      },
      'toggle_coupon_form': function (r) {
        r.preventDefault();
        this.$data.show_coupon_code = !this.$data.show_coupon_code;
      },
      'apply_coupon': function (r) {
        r.preventDefault();
        this.$data.loading = true;
        const url = `${this.API_BASE}/payment/coupon/${this.$props.access_token}`;
        Ajax.ajax('POST', url, {
          'coupon': this.$data.coupon.toUpperCase()
        }).then(r => {
          this.$data.price = r.response.price;
          window.gtag && window.gtag('event', 'questionnaire-action', {
            'event_category': 'coupon-submitted',
            'event_label': this.$data.coupon.toUpperCase(),
            'value': this.$data.price
          });
          if (this.$data.price === 0){
            this.$props.callback();
          } else {
            this.render_screen();
          }
        }).catch(r => {
          alert(r.response && r.response.error && r.response.error.message ? r.response.error.message : 'Something went wrong');
          this.render_screen();
        });
      }
    }
  }
</script>

<style scoped>

    h3 {
        font-size: 1.6rem;
        font-weight: bold;
    }

    .radio-container > li > label {
        text-align: left;
    }

    .payment-texts {
        padding: 2rem;
    }

    .payment-texts p {
        font-size: 1rem;
        line-height: 1.2rem;
    }

    .payment-texts > * {
        margin-top: 0.7rem;
    }

    .payment-texts > *:first-child {
        margin-top: 0;
    }

    .payment-texts.header {
        text-align: center;
        padding-top: 0;
    }

    .payment-texts.header h3 {
        color: #8fbd52;
    }

    .payment-texts.header p {
        font-size: 1.1rem;
        line-height: 1.5rem;
    }

    #payment {
        padding: 3rem;
        max-width: 1024px;
        margin: 0 auto;
    }

    #payment-container-wrapper {
        text-align: center;
        padding: 2rem;
        background: #ffffff;
        border: 1px solid #dddddd;
    }

    #payment-container-wrapper > h3 {
        margin-bottom: 1rem;
    }

    #payment-container {
        margin: 0 auto;
        max-width: 640px;
    }

    #coupon-link {
        margin: 1.5rem auto 0 auto;
    }

    #stripe-form-details {
        margin-top: 0.25rem;
        display: flex;
    }

    #card-errors {
        text-align: left;
        padding-top: 0.25rem;
        padding-right: 1rem;
        width: 100%;
        color: #e37d4e;
    }

    .hr {
        border-top: 1px dotted #dddddd;
    }

    .radio-container li.selected,
    .checkbox-container li.selected {
        box-shadow: 0 1px 0 rgba(0,0,0,0.13) inset, 0 0 0 1px #8fbd52;
        z-index: 2;
        position: relative;
    }

    .payment-method-container {
        padding: 2rem;
    }

    .payment-method-container > * {
        max-width: 480px;
        margin: 0 auto;
    }

    .payment-method-container > .hr {
        max-width: none;
        margin: 1rem 0;
    }

    #card-element {
        border: 1px solid #dddddd;
        border-right: none;
        height: 2.6rem;
        padding: 0.75rem 0 0 0.75rem;
        box-sizing: border-box;
        width: 100%;
    }

    .powered-by-stripe {
        text-align: right;
    }

    .powered-by-stripe img {
        vertical-align: top;
    }

    #coupon-form {
        max-width: 480px;
        margin: 0 auto;
        display: flex;
        padding-top: 1.5rem;
    }

    #coupon-form input {
        padding: 0.5rem;
        border: 1px solid #dddddd;
        border-right: none;
        outline: none;
        width: 100%;
        box-sizing: border-box;
    }

    #coupon-form button {
        white-space: nowrap;
        height: auto;
    }

    @media only screen and (max-width: 1024px) {

        #payment {
            padding: 2rem 1rem;
        }

        .payment-method-container {
            padding: 1rem;
        }

    }

    @media only screen and (max-width: 480px){

        #payment {
            padding: 1rem 0;
        }

        #payment-container-wrapper {
           padding: 1rem;
        }
    }


</style>
